'use client';

import { useEffect, useRef, ReactNode } from 'react';
import { usePathname } from 'next/navigation';

interface PageTransitionProps {
  children: ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  const pathname = usePathname();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    el.classList.remove('page-enter-active');
    void el.offsetWidth; // force reflow
    el.classList.add('page-enter-active');
  }, [pathname]);

  return (
    <div ref={containerRef} className="page-enter">
      {children}
    </div>
  );
}
